/**
 * MCQ Set content type — re-exports element schema with ACH slug `mcq-set`
 */

export {
    mcqSetSchema,
    defaultMCQSetConfig,
    defaultMCQSetData,
    defaultMCQSetI18n,
    type MCQSetContent,
    type MCQSetData,
    type MCQSetConfig,
    type MCQSetLayoutConfig,
    type MCQSetScoringConfig,
    type MCQSetItem,
    type ItemLayout,
} from '@ai-content-hub/content-elements/mcq-set';

export { generateId } from '@ai-content-hub/content-core';
export { mcqElementSchema, type MCQElementData } from '@ai-content-hub/content-elements';

import { generateId } from '@ai-content-hub/content-core';
import { mcqElementSchema, type MCQElementData } from '@ai-content-hub/content-elements';
import type { MCQSetItem } from '@ai-content-hub/content-elements/mcq-set';

export function createMcqSetItem(id?: string): MCQSetItem {
    return {
        id: id ?? generateId(),
        type: 'mcq',
        data: { ...(mcqElementSchema.defaultData as MCQElementData) },
    };
}
